import React, { useState, useEffect, useMemo } from 'react';

import {
  Accordion as AccordionUI,
  AccordionSummary,
  AccordionDetails,
  Typography,
} from '@material-ui/core';
import { ExpandMore } from '@material-ui/icons';
import { isEmpty, isUndefined } from 'lodash';
import PropTypes from 'prop-types';

import * as S from './styles';

export default function Accordion({ accordions }) {
  const [tabs, setTabs] = useState([]);

  const renderTabs = useMemo(
    () =>
      tabs
        .filter(({ isVisible }) => isUndefined(isVisible) || isVisible)
        .map(({ id, title, component: Component }) => (
          <AccordionUI key={id}>
            <AccordionSummary
              expandIcon={<ExpandMore />}
              aria-controls={`${id}-content`}
              id={id}
            >
              <Typography>{title}</Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Component />
            </AccordionDetails>
          </AccordionUI>
        )),
    [tabs]
  );

  useEffect(() => {
    if (!isEmpty(accordions)) setTabs(accordions);
  }, [accordions]);

  return <S.Wrapper>{renderTabs}</S.Wrapper>;
}

Accordion.propTypes = {
  accordions: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
      isVisible: PropTypes.bool,
      component: PropTypes.oneOfType([PropTypes.func, PropTypes.node])
        .isRequired,
    })
  ).isRequired,
};
